import {
  AC_EMAIL_INVALID_DOMAIN_MESSAGE,
  DUPLICATED_EMAIL_MESSAGE,
} from '../../entities/mypage/emailConstants';

type AcEmailCheckResult = {
  valid: boolean;
  exists: boolean;
};

// 未入力と据え置きは保存APIが大学メールの検証をしないため、送信前チェックも行わない。
export const shouldCheckAcEmail = (acEmail: string, initialAcEmail: string) =>
  acEmail !== '' && acEmail !== initialAcEmail;

// 送信前チェックの結果を大学メールアドレス欄に出す文言に変換する。問題なければ undefined を返す。
export const buildAcEmailCheckError = ({
  valid,
  exists,
}: AcEmailCheckResult): string | undefined => {
  if (!valid) {
    return AC_EMAIL_INVALID_DOMAIN_MESSAGE;
  }

  if (exists) {
    return DUPLICATED_EMAIL_MESSAGE;
  }

  return undefined;
};
